let supported = true

if (!window.getComputedStyle) {
  supported = false
} else {
  let testNode = document.createElement('div')

  if (
    !['', '-webkit-', '-moz-', '-ms-'].some(prefix => {
      try {
        testNode.style.position = prefix + 'sticky'
      } catch (e) {}

      return testNode.style.position === prefix + 'sticky'
    })
  ) {
    supported = false
  }
}

if (!supported) {
  import('stickyfilljs').then(Stickyfill => {
    Stickyfill.add(document.querySelectorAll('.sticky'))
  })
}



// WEBPACK FOOTER //
// ./src/js/_sticky.js